import React, { useEffect, useState } from 'react';
import styles from '../styles/albums.module.css';
import { Link } from "react-router-dom";

export default function Albums() {
    const [albums, setAlbums] = useState([]);
    const [loading, setLoading] = useState(false);

    // Запрашиваем на сервере информацию об альбомах
    useEffect(() => {
        const fetchAlbums = async () => {
            try {
                setLoading(true);
                const params = new URLSearchParams({
                    x: '462',
                    y: '260'
                });

                const response = await fetch(
                    `https://apigateway-test.nordciti.ru/v1/GLKAlbums/getAlbums?${params.toString()}`
                    // `https://apigateway.nordciti.ru/v1/GLKAlbums/getAlbums?${params.toString()}`
                );

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const result = await response.json();
                if (result.success && Array.isArray(result.albums)) {
                    setAlbums(result.albums);
                } else {
                    setAlbums([]);
                }
                console.log('API ОТВЕТ getAlbums:', result);
            } catch (error) {
                console.error('getAlbums error:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAlbums();
    }, []);

    if (loading) {
        return (
            <div id='portfolio' className='text-center'>
                <div className='container'>
                    <div className={styles.loaderWrapper}>
                        Загрузка альбомов . . . 
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id='portfolio' className='text-center'>
            <div className='container'>
                <div className='section-title'>
                    <h2>БУДЬ С НАМИ НА ОДНОЙ ВОЛНЕ!</h2>
                </div>

                <div className='row'>
                    {albums?.map(album => (
                        <div key={album.name} className='col-md-4'>
                            <Link to={`/albums/${encodeURIComponent(album.name)}`} className={styles.albumCard}>
                                <div className={styles.imageWrapper}>
                                    <img src={album.previewUrl} alt={album.name} />
                                    <div className={styles.overlay}>
                                        <span>Открыть альбом</span>
                                    </div>
                                </div>
                                <h4>{album.name}</h4>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

